<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	let fields = [
		// political position
		{
			labelName: "politicalposition",
			label: "Which of the following best describes your political position?",
			options: [
				{
					type: "radio",
					value: "1_democrat", // value/response to send to server
					option: "Democrat", // what to display
				},
				{
					type: "radio",
					value: "2_republican",
					option: "Republican",
				},
				{
					type: "radio",
					value: "3_independent",
					option: "Independent",
				},
				{
					type: "radio",
					value: "4_other",
					option: "Other",
				},
			],
		},
		// political preference
		{
			labelName: "politicalpref",
			label: "Which of the following best describes your political preference?",
			options: [
				{
					type: "radio",
					value: "1_strongly-democratic",
					option: "Strongly Democrat",
				},
				{
					type: "radio",
					value: "2_democratic",
					option: "Democratic",
				},
				{
					type: "radio",
					value: "3_lean-democratic",
					option: "Lean Democratic",
				},
				{
					type: "radio",
					value: "4_lean-republican",
					option: "Lean Republican",
				},
				{
					type: "radio",
					value: "5_republican",
					option: "Republican",
				},
				{
					type: "radio",
					value: "6_strongly-republican",
					option: "Strongly Republican",
				},
			],
		},
		// social issues preferences
		{
			labelName: "socialissuespref",
			label: "On social issues, I am...",
			options: [
				{
					type: "radio",
					value: "1_strongly-liberal",
					option: "Strongly Liberal",
				},
				{
					type: "radio",
					value: "2_somewhat-liberal",
					option: "Somewhat Liberal",
				},
				{
					type: "radio",
					value: "3_moderate",
					option: "Moderate",
				},
				{
					type: "radio",
					value: "4_somewhat-conservative",
					option: "Somewhat Conservative",
				},
				{
					type: "radio",
					value: "5_strongly-conservative",
					option: "Strongly Conservative",
				},
			],
		},
		// economic issues preferences
		{
			labelName: "economicissuespref",
			label: "On economic issues, I am...",
			options: [
				{
					type: "radio",
					value: "1_strongly-liberal",
					option: "Strongly Liberal",
				},
				{
					type: "radio",
					value: "2_somewhat-liberal",
					option: "Somewhat Liberal",
				},
				{
					type: "radio",
					value: "3_moderate",
					option: "Moderate",
				},
				{
					type: "radio",
					value: "4_somewhat-conservative",
					option: "Somewhat Conservative",
				},
				{
					type: "radio",
					value: "5_strongly-conservative",
					option: "Strongly Conservative",
				},
			],
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Where you stand on various issues</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
